import React, { useState } from 'react';
import { getStandardDurationOptions } from 'utils/TimeOptionsUtils';
import styles from './DurationSelector.module.scss';
import Select from 'components/UI/V3/Forms/Select';
import clsx from 'clsx';

interface DurationSelectorProps {
    value: string;
    onChange: (value: string) => void;
    label?: string;
    className?: string;
}

export const DurationSelector: React.FC<DurationSelectorProps> = ({
    value,
    onChange,
    label = 'Select Duration',
    className
}) => {
    const [expanded, setExpanded] = useState(false);

    const handleOptionSelect = (option: string) => {
        onChange(option);
        setExpanded(false);
    };

    return (
        <div className={styles.container}>
            <div className={styles.labelContainer}>
                <span className={styles.label}>{label}</span>
            </div>

            <Select
                className={clsx(styles.select, className)}
                value={value}
                options={getStandardDurationOptions('description').map(option => ({
                    value: option.label,
                    label: option.label
                }))}
                onChange={handleOptionSelect}
            ></Select>
        </div>
    );
};
